/**
 * Chart color constants
 * These colors are also defined in Tailwind config (global.css) as:
 * - neutral-blue-1 through neutral-blue-6
 * They can be used as CSS classes (e.g., bg-neutral-blue-1) or as hex values for charts
 */
export const NEUTRAL_CHART_COLORS = [
  '#7B94C6', // neutral-blue-1 - Muted blue
  '#D0DCF2', // neutral-blue-2 - Light blue/lavender
  '#9BA8C4', // neutral-blue-3 - Medium blue-gray
  '#B8C5E0', // neutral-blue-4 - Light blue-gray
  '#6B7FA3', // neutral-blue-5 - Darker blue-gray
  '#C5D1E8', // neutral-blue-6 - Very light blue
] as const

/** Semantic colors for voice pipeline charts — light mode */
export const PIPELINE_CHART_COLORS = {
  eou: '#9ca3af', // gray — end-of-utterance delay
  llm: '#3b82f6', // blue — LLM TTFT
  tts: '#10b981', // green — TTS TTFB
  avgTokens: '#8b5cf6', // violet — avg prompt tokens
  maxTokens: '#f59e0b', // amber — max prompt tokens
  distribution: '#ef4444', // red — latency distribution (use with low opacity)
} as const

/** Muted semantic colors for voice pipeline charts — dark mode */
export const PIPELINE_CHART_COLORS_DARK = {
  eou: '#6b7280', // gray-500
  llm: '#4a80b4', // muted steel blue
  tts: '#3a8a68', // muted teal
  avgTokens: '#7060a8', // muted violet
  maxTokens: '#9e7c30', // muted amber-gold
  distribution: '#a04848', // muted terra cotta
} as const

/** Returns the appropriate pipeline chart color set based on the current theme. */
export function getPipelineChartColors(isDark: boolean) {
  return isDark ? PIPELINE_CHART_COLORS_DARK : PIPELINE_CHART_COLORS
}
